import { createFileRoute, redirect } from '@tanstack/react-router'

import { Loader } from '@/components/loader'
import { OAuthMigrationRoute } from '@/pages/auth/route-entries/oauth-migration'
import { store } from '@/store'
import { buildOAuthRedirectUrl, getBackUrl } from '@/utils/helpers'

export const Route = createFileRoute('/_auth/signup')({
  component: OAuthMigrationRoute,
  pendingComponent: Loader,
  beforeLoad: ({ search }) => {
    const state = store.getState()

    if (!state.isInitialized) {
      return null
    }

    if (state.isAuthorized) {
      throw redirect({
        to: getBackUrl(search.back_url),
      })
    } else {
      if (
        (search.type === 'oauth' && (search.code === undefined || search.code.length === 0)) ||
        !search.type
      ) {
        window.location.href = buildOAuthRedirectUrl(search.back_url)

        return null
      }
    }
  },
})
